module.exports = "<template> <sio-form-row repeat.for=\"field of fields\" field.bind=field></sio-form-row> <div class=clearfix></div> </template> ";